import React from 'react';

export default function PageHeader({ title, accent = 'green', meta, right }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between',
      gap: 16, padding: '24px 32px 8px',
    }}>
      <div>
        <div style={{
          fontSize: 11, fontWeight: 600, color: `var(--sec-${accent})`,
          letterSpacing: '0.05em', textTransform: 'uppercase', marginBottom: 4,
        }}>{meta || ' '}</div>
        <h1 style={{
          margin: 0, fontSize: 32, fontWeight: 700, letterSpacing: '-0.02em',
          color: `var(--sec-${accent})`, fontFamily: 'var(--font-display)',
        }}>{title}</h1>
      </div>
      {right}
    </div>
  );
}
